const cod5AnalyticsId = "";

declare global {
  interface Window {
    COD5_ANALYTICS_ID?: string;
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

export function installAnalytics() {
  const measurementId = window.COD5_ANALYTICS_ID || cod5AnalyticsId;
  if (!measurementId || document.querySelector(`script[data-cod5-analytics="${measurementId}"]`)) return;

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`;
  script.dataset.cod5Analytics = measurementId;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = (...args: unknown[]) => window.dataLayer?.push(args);
  window.gtag("js", new Date());
  window.gtag("config", measurementId);
}

